"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Sign Internal OpenAPI
 * Sign Internal OpenAPI spec
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiAppResponseWhiteLabelingOptionsToJSON = exports.ApiAppResponseWhiteLabelingOptionsFromJSONTyped = exports.ApiAppResponseWhiteLabelingOptionsFromJSON = exports.instanceOfApiAppResponseWhiteLabelingOptions = exports.ApiAppResponseWhiteLabelingOptionsLegalVersionEnum = exports.attributeTypeMapApiAppResponseWhiteLabelingOptions = void 0;
exports.attributeTypeMapApiAppResponseWhiteLabelingOptions = [
    {
        name: "headerBackgroundColor",
        type: "string",
    },
    {
        name: "legalVersion",
        type: "string",
    },
    {
        name: "linkColor",
        type: "string",
    },
    {
        name: "pageBackgroundColor",
        type: "string",
    },
    {
        name: "primaryButtonColor",
        type: "string",
    },
    {
        name: "primaryButtonColorHover",
        type: "string",
    },
    {
        name: "primaryButtonTextColor",
        type: "string",
    },
    {
        name: "primaryButtonTextColorHover",
        type: "string",
    },
    {
        name: "secondaryButtonColor",
        type: "string",
    },
    {
        name: "secondaryButtonColorHover",
        type: "string",
    },
    {
        name: "secondaryButtonTextColor",
        type: "string",
    },
    {
        name: "secondaryButtonTextColorHover",
        type: "string",
    },
    {
        name: "textColor1",
        type: "string",
    },
    {
        name: "textColor2",
        type: "string",
    },
];
/**
 * @export
 */
exports.ApiAppResponseWhiteLabelingOptionsLegalVersionEnum = {
    Terms1: "terms1",
    Terms2: "terms2",
};
/**
 * Check if a given object implements the ApiAppResponseWhiteLabelingOptions interface.
 */
function instanceOfApiAppResponseWhiteLabelingOptions(value) {
    if (!("headerBackgroundColor" in value) ||
        value["headerBackgroundColor"] === undefined)
        return false;
    if (!("legalVersion" in value) || value["legalVersion"] === undefined)
        return false;
    if (!("linkColor" in value) || value["linkColor"] === undefined)
        return false;
    if (!("pageBackgroundColor" in value) ||
        value["pageBackgroundColor"] === undefined)
        return false;
    if (!("primaryButtonColor" in value) ||
        value["primaryButtonColor"] === undefined)
        return false;
    if (!("primaryButtonColorHover" in value) ||
        value["primaryButtonColorHover"] === undefined)
        return false;
    if (!("primaryButtonTextColor" in value) ||
        value["primaryButtonTextColor"] === undefined)
        return false;
    if (!("primaryButtonTextColorHover" in value) ||
        value["primaryButtonTextColorHover"] === undefined)
        return false;
    if (!("secondaryButtonColor" in value) ||
        value["secondaryButtonColor"] === undefined)
        return false;
    if (!("secondaryButtonColorHover" in value) ||
        value["secondaryButtonColorHover"] === undefined)
        return false;
    if (!("secondaryButtonTextColor" in value) ||
        value["secondaryButtonTextColor"] === undefined)
        return false;
    if (!("secondaryButtonTextColorHover" in value) ||
        value["secondaryButtonTextColorHover"] === undefined)
        return false;
    if (!("textColor1" in value) || value["textColor1"] === undefined)
        return false;
    if (!("textColor2" in value) || value["textColor2"] === undefined)
        return false;
    return true;
}
exports.instanceOfApiAppResponseWhiteLabelingOptions = instanceOfApiAppResponseWhiteLabelingOptions;
function ApiAppResponseWhiteLabelingOptionsFromJSON(json) {
    return ApiAppResponseWhiteLabelingOptionsFromJSONTyped(json, false);
}
exports.ApiAppResponseWhiteLabelingOptionsFromJSON = ApiAppResponseWhiteLabelingOptionsFromJSON;
function ApiAppResponseWhiteLabelingOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        headerBackgroundColor: json["header_background_color"],
        legalVersion: json["legal_version"],
        linkColor: json["link_color"],
        pageBackgroundColor: json["page_background_color"],
        primaryButtonColor: json["primary_button_color"],
        primaryButtonColorHover: json["primary_button_color_hover"],
        primaryButtonTextColor: json["primary_button_text_color"],
        primaryButtonTextColorHover: json["primary_button_text_color_hover"],
        secondaryButtonColor: json["secondary_button_color"],
        secondaryButtonColorHover: json["secondary_button_color_hover"],
        secondaryButtonTextColor: json["secondary_button_text_color"],
        secondaryButtonTextColorHover: json["secondary_button_text_color_hover"],
        textColor1: json["text_color1"],
        textColor2: json["text_color2"],
    };
}
exports.ApiAppResponseWhiteLabelingOptionsFromJSONTyped = ApiAppResponseWhiteLabelingOptionsFromJSONTyped;
function ApiAppResponseWhiteLabelingOptionsToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        header_background_color: value["headerBackgroundColor"],
        legal_version: value["legalVersion"],
        link_color: value["linkColor"],
        page_background_color: value["pageBackgroundColor"],
        primary_button_color: value["primaryButtonColor"],
        primary_button_color_hover: value["primaryButtonColorHover"],
        primary_button_text_color: value["primaryButtonTextColor"],
        primary_button_text_color_hover: value["primaryButtonTextColorHover"],
        secondary_button_color: value["secondaryButtonColor"],
        secondary_button_color_hover: value["secondaryButtonColorHover"],
        secondary_button_text_color: value["secondaryButtonTextColor"],
        secondary_button_text_color_hover: value["secondaryButtonTextColorHover"],
        text_color1: value["textColor1"],
        text_color2: value["textColor2"],
    };
}
exports.ApiAppResponseWhiteLabelingOptionsToJSON = ApiAppResponseWhiteLabelingOptionsToJSON;
